import { MonitorPlay } from '@phosphor-icons/react';

export default MonitorPlay;
